var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.elementClass},[_c('div',{ref:"scrollArea",staticClass:"scroll-area"},[_vm._t("default"),_c('div',{ref:"focusLine",staticClass:"focus-line"})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }